import { mapState } from 'pinia';
import stores from 'store/modules';

export default {
    data: () => ({
        autoRechargeStatus: null,
        togglingAutoRecharge: false,
    }),

    computed: {
        loadingAutoRecharge() {
            return !this.autoRecharge || this.autoRechargeStatus === null;
        },

        ...mapState(stores.Organization, ['organization']),
        ...mapState(stores.AutoRecharge, ['autoRecharge']),
    },

    watch: {
        autoRecharge(val) {
            if (val) {
                this.autoRechargeStatus = val.is_active;
            }
        },
    },

    methods: {
        loadAutoRecharge() {
            this.$store.dispatch('getBillingAutoRecharge');
        },

        toggleAutoRecharge({ value }) {
            this.autoRechargeStatus = value;
            this.togglingAutoRecharge = true;

            this.$store
                .dispatch('updateBillingAutoRecharge', value)
                .then(() => {
                    this.$store.dispatch('showToast', {
                        type: 'success',
                        message: value
                            ? 'Auto Recharge has been turned on.'
                            : 'Auto Recharge has been turned off.',
                    });
                })
                .catch(() => {
                    this.autoRechargeStatus = !value;

                    this.$store.dispatch('showToast', {
                        type: 'danger',
                        message: value
                            ? 'Failed to turn on Auto Recharge.'
                            : 'Failed to turn off Auto Recharge.',
                    });
                })
                .finally(() => {
                    this.togglingAutoRecharge = false;
                });
        },
    },

    mounted() {
        this.loadAutoRecharge();
    },
};
